import API_Call_Handler from "@/api/API_Call_Handler";
import API_Calls_Utils from "@/api/API_Calls_Utils";
import { getBackendUrl } from "@/utils/util";

export default function API_Calls_UsersTable() {
  const backendUrl = getBackendUrl();
  const { apiCall } = API_Call_Handler();
  const { queryParamsAndHeaders } = API_Calls_Utils();

  async function getUsers(org_id, managementToken, data_source) {
    try {
      const { headers, queryString } = await queryParamsAndHeaders(
        { org_id, data_source },
        managementToken
      );
      const users = await apiCall({
        url: `${backendUrl}/api/affiliate_admin/users?${queryString}`,
        headers,
      });
      return users.data;
    } catch {
      return [];
    }
  }

  async function getAffiliates(managementToken) {
    try {
      const { headers } = await queryParamsAndHeaders({}, managementToken);
      const affiliates = await apiCall({
        url: `${backendUrl}/api/system_admin/affiliates`,
        headers,
      });
      return affiliates.data;
    } catch {
      return [];
    }
  }

  async function editUser(user_id, newUserData, managementToken) {
    try {
      const { headers, queryString } = await queryParamsAndHeaders(
        { user_id },
        managementToken
      );
      return await apiCall({
        method: "PATCH",
        url: `${backendUrl}/api/affiliate_admin/user?${queryString}`,
        headers,
        data: newUserData,
      });
    } catch {
      return { status: undefined };
    }
  }

  async function inviteUserSystemAdmin(
    org_id,
    invited_user_name,
    invited_user_email,
    role,
    managementToken,
    data_source
  ) {
    try {
      const { headers, queryString } = await queryParamsAndHeaders(
        { org_id, invited_user_name, invited_user_email, role, data_source },
        managementToken
      );
      return await apiCall({
        method: "POST",
        url: `${backendUrl}/api/system_admin/invite?${queryString}`,
        headers,
      });
    } catch {
      return { status: undefined };
    }
  }

  async function inviteUserAffiliateAdmin(
    org_id,
    invited_user_name,
    invited_user_email,
    managementToken
  ) {
    try {
      const { headers, queryString } = await queryParamsAndHeaders(
        { org_id, invited_user_name, invited_user_email },
        managementToken
      );
      return await apiCall({
        method: "POST",
        url: `${backendUrl}/api/affiliate_admin/invite?${queryString}`,
        headers,
      });
    } catch {
      return { status: undefined };
    }
  }

  async function deleteUser(org_id, user_id, managementToken) {
    try {
      const { headers, queryString } = await queryParamsAndHeaders(
        { org_id, user_id },
        managementToken
      );
      return await apiCall({
        method: "DELETE",
        url: `${backendUrl}/api/affiliate_admin/user?${queryString}`,
        headers,
      });
    } catch {
      return { status: undefined };
    }
  }

  return {
    getUsers,
    deleteUser,
    editUser,
    inviteUserAffiliateAdmin,
    inviteUserSystemAdmin,
    getAffiliates,
  };
}
